import React from "react";
import { Typography } from "@mui/material";

import Button from "@material-ui/core/Button";
import SubpageHeader from "../container/SubpageHeader";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
          <>
            <SubpageHeader>
              <Typography variant="h5">Whoops</Typography>
            </SubpageHeader>

            <div style={{ height: 600, width: "100%" }}>
                <Typography variant="body1">We can't access this page for you right now.</Typography>
            </div>
          </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
